import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { LanguageIdentifier } from '@app/core/models';

export interface AppStateModel {
  authenticated: boolean;
  language: LanguageIdentifier;
  error: boolean;
}

function createInitialState(): AppStateModel {
  return {
    authenticated: null,
    language: null,
    error: false
  };
}

@Injectable()
@StoreConfig({ name: 'app' })
export class AppStateStore extends Store<AppStateModel> {

  constructor() {
    super(createInitialState());
  }
}
